import axios from 'axios';

axios.defaults.withCredentials = true
const $axios = axios.create({
    // baseURL: "http://192.168.72.219:8080",
    headers:{
        "Content-Type":"application/x-www-form-urlencoded",
    }
})

const getList = (url, data) => {
    return $axios.get(url)
}
const postInfo = (url, data) => {
    return $axios.post(url, data)
}
const putInfo = (url, data) => {
    return $axios.put(url, data)
}
export {
    getList,
    postInfo,
    putInfo
}